export default {
  activity_handprint_01: {
    title:
      'Jeg kontaktet en politiker eller produsent med krav/oppfordring om å gjøre en endring for mindre plastforbruk og/eller plastforsøpling idag',
    description:
      'Kan registeres når du sender e-post, Facebook-melding  eller på annet vis kontakter en politiker eller produsent med en oppfordring eller krav om endring for å redusere plastforbruket eller plastforsøplingen',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Fakta
- Som forbruker kan du bidra til å endre klesbransjen og andre bransjer som bruker plast! Ta et oppgjør med (kles)produsentene og si ifra at du som forbruker ønsker mer miljøvennlige klær og produkter. Det nytter! Bevissthet blant forbrukere er også avgjørende, så fremsnakk gjerne gode alternativer blant venner og familie.`,
  },
  activity_handprint_02: {
    title: 'Jeg arrangerte et plastfritt arrangement eller feiring i dag',
    description:
      'Du kan registrere hver gang du arrangerer en plastfri bursdag, feiring, familiemiddag o.l.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    biodiversity_explanation: `MARKDOWN:
## Fakta
- Sugerør, ballongpinner, tallerkener, glass og kopper av plast blir forbudt i EU fra 2021, og allerede fra 2020 i Norge. Unødvendig engangsplast er et stort avfallsproblem, så det er fantastisk at det nå settes ned forbud mot noen av produktene som har hatt en tendens til å havne i naturen.

## Tilleggsinformasjon
- [https://www.regjeringen.no/contentassets/cd7a6a52deff435d83daa759f60e612d/nasjonalt-forbud-mot-enkelte-plastprodukter---forslag-til-forskrift-og-horingsnotat.pdf](https://www.regjeringen.no/contentassets/cd7a6a52deff435d83daa759f60e612d/nasjonalt-forbud-mot-enkelte-plastprodukter---forslag-til-forskrift-og-horingsnotat.pdf)`,
    handprint_explanation: `MARKDOWN:
## Fakta 
- Ved å arrangere en plastfri middag eller et plastfritt arrangement er du med på å naturliggjøre en sosial hverdag uten unødvendige engangsprodukter!

## Tips
- [https://www.framtiden.no/gronne-tips/fritid/gronn-feiring.html](https://www.framtiden.no/gronne-tips/fritid/gronn-feiring.html)
- [https://www.framtiden.no/gronne-tips/fritid/slik-kan-du-redusere-engangsplasten.html](https://www.framtiden.no/gronne-tips/fritid/slik-kan-du-redusere-engangsplasten.html)

## Tips til ballongvettregler
- [https://holdnorgerent.no/ballongvett](https://holdnorgerent.no/ballongvett)`,
  },
  activity_handprint_03: {
    title: 'Jeg plukket minst fem plastartikler på avveie i dag',
    description:
      'Kan registreres hver dag du plukker minst fem plastartikler som har havnet på avveie',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    biodiversity_explanation: `MARKDOWN:
## Fakta
- Det meste av plasten som er produsert har endt opp som avfall. Det er vanskelig å fastslå akkurat hvor mye avfall som produseres årlig på grunn av de store variasjonene i plastens levetid. Mens noen produkter blir til avfall etter kort tid, lever andre videre i flere tiår. Dermed kan det i noen år være mer avfall enn det produseres. Det anslås at mindre enn 10 % av plasten om er produsert mellom 1950-2015 er blitt resirkulert, noe blir brent mens det aller meste havner på dynga eller på avveie.

## Tilleggsinformasjon 
- [https://holdnorgerent.no/](https://holdnorgerent.no/)

## Tips til hvordan å arrangere plastryddearrangement
- [https://holdnorgerent.no/wp-content/uploads/2017/04/Hold-Norge-Rents-ryddeveileder.pdf](https://holdnorgerent.no/wp-content/uploads/2017/04/Hold-Norge-Rents-ryddeveileder.pdf)`,
    co2_explanation: `MARKDOWN:
## Fakta
- Over halvparten av all plast som har blitt produsert har havnet på landfyllinger. Plast som havner på landfyllinger slipper ut CO\u2082 og metan, to sterke klimagasser. Samtidig brytes plasten opp og blir til mikroplast. Mye blir også tatt av vind og vann og havner på avveie i naturen og i havet.`,
    handprint_explanation: `MARKDOWN:
## Fakta
- Når man plukker plast er man med på å synliggjøre de enorme mengdene plast som havner på avveie. Rydder du plast sammen med andre bidrar du både til å redusere plastforsøpling og til bevisstgjøring.
- Årets TV-aksjon går til WWF og skal bekjempe plast i havet gjennom å etablere og forbedre eksisterende avfallssystemer for mer enn 900 000 mennesker. I samarbeid med lokalbefolkning, myndigheter og næringsliv skal WWF redusere utslipp av plast til elver og hav med 7000 tonn årlig. De skal samle inn og resirkulere søppel som i dag ender opp i naturen, redusere bruken av unødvendig plast og jobbe for at beslutningstakere forplikter seg til å nå WWFs mål om null plast på avveie i 2030. Bli digital bøssebærer, og sjekk ut: [https://www.blimed.no/tv-aksjonen-nrk/tv-aksjonen-2020/](https://www.blimed.no/tv-aksjonen-nrk/tv-aksjonen-2020/)`,
  },
  activity_handprint_04: {
    title: 'Jeg sørget for at jeg ikke la igjen plast etter meg i dag',
    description:
      'Vær obs på «småplasten» som lett faller utenfor søppelkasser eller blir liggende igjen på en benk eller på bussetet etter deg.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Fakta
- i 2020 går TV-aksjonen til WWF og kampen mot plast i havet.

## Tilleggsinformasjon
- [https://blimed.no/tv-aksjonen-nrk/tv-aksjonen-2020/](https://blimed.no/tv-aksjonen-nrk/tv-aksjonen-2020/)`,
    biodiversity_explanation: `MARKDOWN:
## Fakta
- Mer enn 8 millioner tonn plastavfall havner i havet årlig! Enda mer sjokkerende blir det når man tenker på at disse 8 millionene kun tilsvarer 3% av den årlige mengden plastavfall! Det aller meste av plast på avveie grunnes dårlig avfallshåndtering, spesielt i lavinntektsland. Samtidig er tendensen at det er de rikeste landene som genererer mest plastavfall per person. På grunn av bedre avfallshåndtering i rike land, er det lavinntektsland som står som de verste plastforsøplerne. Plasten som havner på avveie finner ofte veien til vannveier og via vind til elver som igjen renner ut i havet.`,
  },
  activity_handprint_05: {
    title:
      'Jeg oppfordret mitt kommunale avfallsselskap til å bedre avfallssystemet sitt i dag',
    description:
      'Kan registeres hvis du i en henvendelse til ditt kommunale avfallsselskap oppfordrer til bedring av avfallssystemet og/eller resirkuleringen av plast',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Fakta
- Kildesorteringen varierer fra kommune til kommune i Norge. Det er fordi det er kommunene som bestemmer hvilke kildesorteringsordninger de skal ha. Dermed kan du ta kontakt med kommunepolitikere og/eller ditt kommunale renovasjonsselskap for å kreve bedre avfallshåndtering der det mangler eller er mangelfullt.

## Tilleggsinformasjon
- [https://sortere.no/](https://sortere.no/)`,
    biodiversity_explanation: `MARKDOWN:
## Fakta
- Det er de rikeste landene som genererer mest plastavfall per person. På grunn av dårligere avfallshåndtering er det allikevel lavinntektsland som står som de verste plastforsøplerne. Vi må allikevel ta vårt ansvar her hjemme ved å redusere avfallsmengden og bidra til bedre avfallshåndtering.`,
  },
  activity_handprint_06: {
    title:
      'Jeg oppfordret nærbutikken min til å redusere plastforbruket sitt i dag',
    description:
      'Kan registreres hver dag du har oppfordret din nærbutikk til å redusere plastforbruket og/eller finne bedre alternativer til emballasje enn plast',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Fakta
- Butikkene er opptatt av hva forbrukerne mener. Butikker lever av å ha kunder, og dermed er de avhengig av å tilpasse seg hva markedet ønsker. Hvis mange nok oppfordrer eller krever at butikkene skal redusere plastforbruket sitt, har vi en enorm påvirkningskraft!`,
    biodiversity_explanation: `MARKDOWN:
## Fakta
- Plastens største marked er emballasje. Over 40 % av all plast produsert er emballasje. Emballasje er også den produktgruppen med lavest levetid, da mye består av engangsartikler. Mye av emballasjen havner dessverre på avveie og ender opp i naturen og i havet.`,
  },
  activity_handprint_07: {
    title: 'Jeg fikk en jeg kjenner til å gjøre et plasttiltak i dag',
    description:
      'Registreres hvis du fikk en du kjenner til å gjøre en av aktivitetene i plastutfordringen',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Fakta
- Flere studier viser at handling fører til holdning, og at den sosiale nettverks-effekten (også kalt «naboeffekten») er en sterk driver til folks handlinger. For eksempel er det vist at nabolag der noen først kjøper el-bil eller installerer solcellepanel på taket, er de samme områdene med størst vekst i nettopp elbil og solceller. Med andre ord er dine handlinger med på å påvirke hva andre gjør. Får du andre til å gjøre et plasttiltak bidrar du til å skape en ny grønn trend. Heia deg!

## Tilleggsinformasjon
- [https://www.nettavisen.no/na24/norsk-studie-slik-pavirker-naboens-elbilkjop-deg/3423590868.html](https://www.nettavisen.no/na24/norsk-studie-slik-pavirker-naboens-elbilkjop-deg/3423590868.html) 
- Les mer om sosiale normer og klimakommunikasjon: [https://biopen.bi.no/bi-xmlui/bitstream/handle/11250/278817/Stoknes_ERSS_2014.pdf?sequence=5](https://biopen.bi.no/bi-xmlui/bitstream/handle/11250/278817/Stoknes_ERSS_2014.pdf?sequence=5)  
- Les mer om sosiale normer og energibesparelse: [https://www.sciencedirect.com/science/article/abs/pii/S0047272711000478?via%3Dihub](https://www.sciencedirect.com/science/article/abs/pii/S0047272711000478?via%3Dihub)`,
  },
  activity_handprint_08: {
    title: 'Jeg lærte noe nytt om plast i dag',
    description: 'Kan registeres hver dag du har lært noe nytt om plast!',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Fakta
- Du har stor påvirkningskraft både som forbruker og som enkeltindivid. Gjennom å lære deg mer om plast kan du føle deg tryggere på at du tar riktige valg på butikken og påvirker folk rundt deg i riktig retning.`,
  },
  activity_handprint_09: {
    title: 'Jeg oppfordret til forhindring av gummigranulat på avveie i dag',
    description:
      'Kan registreres når du prater med laglederen/baneansvarlig for ditt lokale idrettslag om konkrete tiltak for å hindre gummigranulat på avveie',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Gummigranulater er laget av gjenvunnede bildekk og kan dermed også inneholde miljøgifter som for eksempel PAH, ftalater, tungmetaller og fenoler.`,
    handprint_explanation: `MARKDOWN:
## Fakta
- Miljødirektoratet har laget et forslag til forskrift om «utforming og drift av idrettsbaner der det brukes plastholdig løst fyllmateriale» for å redusere bruken av plast på idrettsanlegg. Forslaget har dessverre stoppet opp og ennå ikke blitt vedtatt. Her kan baneledere, lagledere, idrettslag og vi som enkeltpersoner pushe politikere til å vedta forskriften og iverksette konkrete tiltak som monner.

## Tilleggsinformasjon
- Utkast til forskrift om drift og etablering av idrettsbaner med gummigranulat: [https://tema.miljodirektoratet.no/Global/dokumenter/horinger/Industri/Forskrift%20om%20kunstgressbaner.pdf?epslanguage=no](https://tema.miljodirektoratet.no/Global/dokumenter/horinger/Industri/Forskrift%20om%20kunstgressbaner.pdf?epslanguage=no)

## Tips
Her er konkrete tiltak du kan tipse laglederen/banelederen din om, for å forhindre mikroplast på avveie: 

a) en fysisk barriere rundt idrettsbanen som hindrer at plastholdig løst fyllmateriale spres utenfor banen. Minst 20 centimeter av barrierens høyde, målt fra bakken, skal være tett.,

b) løsninger for håndtering av drensvann og overvann som sikrer oppsamling av løst plastholdig fyllmateriale slik at dette ikke spres utenfor banen, og

c) tiltak som hindrer at plastholdig løst fyllmateriale spres utenfor banen via brukere av banen.

Andre tiltak: drenerende oppbygning, kant/mur rundt banen, gjerde, granulatfilter i kummer, granulatoppsamlingskummer ved inngangspartiene, granulatfrie kunstgressystemer, etablering av inngangsparti med mulighet for å rense sko/tøy, bruk av granulatfrie underlag, bruk av granulat uten plast/kunstsstoffer, kunstgress som legges helt ut til kant/mur, asfaltkant med fall inn mot banen, vedlikehold, opplæring, sikker lagring av snø og etablering av eget snødeponi (ikke utenfor banen).`,
    biodiversity_explanation: `MARKDOWN:
## Fakta 
- Det spres omtrent 1500 tonn gummigranulat fra norske kunstgressbaner hvert år! Dette gjør at kunstgressbaner er den nest største kilden til mikroplastutslipp i Norge. 
- En kartlegging gjennomført av Rambøll Norge AS viser at kun 5% av idrettsanleggene har tatt hensyn til sårbare resipienter ved lokaliseringen av kunstgressanlegget og hele 40% av alle banene befinner seg i nærheten av sårbare resipienter som bekker, elver, sjøer og kyst. Det anslås at det tilføres i gjennomsnitt 5,5 tonn gummigranulat på anlegg hvert år.

## Tilleggsinformasjon
- Les mer om kilder til mikroplast i Norge [https://miljostatus.miljodirektoratet.no/tema/avfall/avfallstyper/mikroplast/](https://miljostatus.miljodirektoratet.no/tema/avfall/avfallstyper/mikroplast/)
- Les merom kartlegging av norske kunstgressbaner [https://www.miljodirektoratet.no/globalassets/publikasjoner/M954/M954.pdf](https://www.miljodirektoratet.no/globalassets/publikasjoner/M954/M954.pdf)
- Utkast til forskrift om drift og etablering av idrettsbaner med gummigranulat [https://tema.miljodirektoratet.no/Global/dokumenter/horinger/Industri/Forskrift%20om%20kunstgressbaner.pdf?epslanguage=no](https://tema.miljodirektoratet.no/Global/dokumenter/horinger/Industri/Forskrift%20om%20kunstgressbaner.pdf?epslanguage=no)`,
  },
  activity_handprint_10: {
    title: 'Jeg prøvde å påvirke noen til å ta mer klimavennlige valg i dag',
    description:
      'Snakk med familie, venner, kollegaer eller engasjer deg i samtaler på sosiale medier.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    co2_explanation: `MARKDOWN:
## Fakta
- Å snakke om bærekraft oftere og på flere arenaer kan hjelpe oss å finne gode løsninger på hverdagsutfordringene sammen. 
- Det finnes mange gode tips til hvordan man kan snakke om bærekraft med sine nærmeste på en måte som bygger bruer i stedet for murer. Se mer under info seksjonen.

## Hva vi antar
- Det kan ha stor klimaeffekt å dele sine tanker med andre. En person du snakker med kan bli inspirert til å snakke med andre, til å stemme på grønne politikere eller til å kjøpe bærekraftige produkter og tjenester.

## Tilleggsinformasjon
- [https://www.weforum.org/agenda/2018/06/how-to-talk-about-climate-change-5-tips-from-the-front-lines/](https://www.weforum.org/agenda/2018/06/how-to-talk-about-climate-change-5-tips-from-the-front-lines/)
- [https://www.ted.com/talks/per_espen_stoknes_how_to_transform_apocalypse_fatigue_into_action_on_global_warming](https://www.ted.com/talks/per_espen_stoknes_how_to_transform_apocalypse_fatigue_into_action_on_global_warming)
`,
  },
  activity_handprint_11: {
    title: 'Jeg har inspirert familie eller venner til å spise vegetar i dag',
    description: '',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
  },
  activity_handprint_12: {
    title: 'Jeg vasket hendene mine ofte i dag',
    description:
      'Logges dersom du vasket hendene dine grundig og regelmessig med såpe og vann, eller desinfiserende alkohol.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Grundig håndvask med såpe eller håndsprit dreper virus som du kan ha fått på hendene.

## Tilleggsinformasjon
- [https://apps.who.int/iris/bitstream/handle/10665/44102/9789241597906_eng.pdf;jsessionid=8C2C569869D577AFBF4192156149A4CE?sequence=1](https://apps.who.int/iris/bitstream/handle/10665/44102/9789241597906_eng.pdf;jsessionid=8C2C569869D577AFBF4192156149A4CE?sequence=1)`,
  },
  activity_handprint_13: {
    title: 'Jeg opprettholdt fysisk distansering i dag',
    description: 'Logges hver dag du holdt deg minst 1 meter unna andre.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Fysisk distansering er den mest effektive måten å bremse smitten av COVID-19. Når noen hoster eller nyser, spres små dråpepartikler fra nese eller munn som inneholder virus. Står du for nærme så risikerer du å puste inn dråpene, inkludert COVID-19 om den som hoster har det. Fysisk distansering holder deg og andre trygg. Du kan også bidra til å redde livet til mennesker i risikogruppen som de med kroniske sykdommer, problemmer med immunforsvaret, og de eldre.

## Tilleggsinformasjon
- [https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3372334/](https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3372334/)`,
  },
  activity_handprint_14: {
    title: 'Jeg hadde god luftveishygiene i dag',
    description:
      'Logges hver dag du hoster i albuekroken eller et lommetørkle, samt om du lar være å ta deg selv på øye, nese og munn.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Dråper sprer virus. Ved å ha god lufteveishygene kan du beskytte de rundt deg mot virus som forkjølelse, influensa, og COVID-19. Vi berører mange overflater med hendene og kan dermed plukke opp virus.
- Hendene kan videre føre viruset inn i kroppen når du tar deg i øyene, nesen eller munnen. Derfra kan virus trenge inn i kroppen og gjøre deg syk.

## Tilleggsinformasjon
- [https://link.springer.com/article/10.1007/s00348-015-2078-4](https://link.springer.com/article/10.1007/s00348-015-2078-4)`,
  },
  activity_handprint_15: {
    title: 'Jeg begynte på et nettkurs i dag',
    description:
      'Logges hver dag du starter på et nettbasert kurs for å lære noe nytt.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Å lære noe nytt er gøy og en god måte å slippe å kjede seg. Det kan også øke selvtillit. I tillegg kan det gjøre deg mer lykkelig.

## Tilleggsinformasjon
- [https://www.ted.com/talks/carol_dweck_the_power_of_believing_that_you_can_improve?language=en](https://www.ted.com/talks/carol_dweck_the_power_of_believing_that_you_can_improve?language=en)
- [https://www.psychologies.co.uk/want-be-happier-learn-something-new](https://www.psychologies.co.uk/want-be-happier-learn-something-new)
- [https://anuschkarees.com/blog/2015/01/22/how-to-make-learning-and-personal-development-a-regular-part-of-your-life](https://anuschkarees.com/blog/2015/01/22/how-to-make-learning-and-personal-development-a-regular-part-of-your-life)`,
  },
  activity_handprint_16: {
    title: 'Jeg lærte bort noe i dag',
    description:
      'Logges hver dag du lærer bort noe du kan godt til noen andre.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Å lære bort noe gir deg muligheten til å dele det du brenner for og inspirere andre, samt øke selvtillit og bidra til samfunnet. Å hjelpe andre reduserer også stress. For noen utrolige fordeler!

## Tilleggsinformasjon
- [https://www.apa.org/monitor/dec06/helping](https://www.apa.org/monitor/dec06/helping)
- [https://blogs.volunteermatch.org/engagingvolunteers/2018/12/04/volunteering-and-psychological-health/](https://blogs.volunteermatch.org/engagingvolunteers/2018/12/04/volunteering-and-psychological-health/)`,
  },
  activity_handprint_17: {
    title: 'Jeg trente i dag',
    description: 'Logges hver dag du mosjonerte deg.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Trening er utrolig bra for alle sider av helsa. Du holder deg i form, øker energinivået, og forbedrer mental helse ved å redusere stress, angst og depresjon.

## Tilleggsinformasjon
- [https://medlineplus.gov/benefitsofexercise.html](https://medlineplus.gov/benefitsofexercise.html)`,
  },
  activity_handprint_18: {
    title:
      'Jeg hadde en positiv samtale med noen jeg er glad i eller en gammel venn i dag',
    description:
      'Logges hver dag du snakker med en venn på telefon eller video.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    social_explanation: `MARKDOWN:
## Fakta
- Å snakke sammen er en måte å føle seg koblet til andre på. Det gir mulighet til å justere våre tanker og følelser og gir lettelse. Å høre på noen bidrar til å utvikle tålmodighet og gjensidig tillitt

## Tilleggsinformasjon
- [https://www.psychologytoday.com/us/blog/the-chronicles-infertility/201808/the-power-talking](https://www.psychologytoday.com/us/blog/the-chronicles-infertility/201808/the-power-talking)
- [https://hbr.org/1957/09/listening-to-people](https://hbr.org/1957/09/listening-to-people)`,
  },
  activity_handprint_19: {
    title: 'Jeg ble hjemme i dag',
    description:
      'Logges hver dag du holder deg hjemme for å begrense smittefare.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
- Ved å unngå kontakt med andre unngår du smitte; ved å unngå å dra til legen kan sykehusene effektivt behandle de som trenger det.
- Hold deg hjemme om du er uvel, selv om det er bare milde symptomer som hodepine eller at du er tett i nesa.`,
  },
  activity_handprint_20: {
    title: 'Jeg holdt meg oppdatert på helsemyndighetenes råd',
    description:
      'Logges hver dag du tar deg til å holde deg oppdatert på COVID-19 utviklinger samt helsemyndighetenes råd.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
- Myndighetene har den mest oppdaterte informasjonen om COVID-19 spredning i ditt nærområde. De er best skikket til å rådføre hvordan du skal beskytte deg.
- Hold deg oppdatert på utviklingen til COVID-19. Følg råd fra din lege, Folkehelseinstituttet og din arbeidsgiver om hvordan du best kan beskytte deg selv og andre mot COVID-19.

## Tilleggsinformasjon
- [https://www.fhi.no/sv/smittsomme-sykdommer/corona/](https://www.fhi.no/sv/smittsomme-sykdommer/corona/)`,
  },
  activity_handprint_21: {
    title: 'Jeg snakket om mindfullness i dag',
    description:
      'Logges hver dag du snakket om fordelene med å være bevisst tilstede og omsorgfull ovenfor andre.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Fakta
- Å snakke om mindfulness kan bidra til å finne løsninger til hverdagsutfordringer sammen, ved å skape og bidra til en fredelig og bevisst samfunn.
- Ved å snakke om fordelene ved mindfulness kan du stimulere til samfunnsutvikling.
- Gjerne ta en titt på foredget til Diana Winston fra UCLA's Mindful Awareness Research Center om hvordan medlidenhet for seg selv er et viktig grunnlag for å kunne ha medlidenhet for andre og verden.

## Tilleggsinformasjon
- [https://www.youtube.com/watch?v=oMlaSCxZPN4](https://www.youtube.com/watch?v=oMlaSCxZPN4)
- [https://positivepsychology.com/mindful-self-compassion/](https://positivepsychology.com/mindful-self-compassion/)
- [https://www.health.harvard.edu/mind-and-mood/mindfulness-not-just-for-stress-reduction](https://www.health.harvard.edu/mind-and-mood/mindfulness-not-just-for-stress-reduction)
- [https://www.health.harvard.edu/staying-healthy/the-magic-of-mindfulness](https://www.health.harvard.edu/staying-healthy/the-magic-of-mindfulness)`,
  },
  activity_handprint_22: {
    title: 'Jeg delte faktabasert informasjon i dag',
    description:
      'Logges hver dag du sjekket at informasjon du delte var faktabasert',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Fakta
- Stigma sårer alle ved å skape frykt eller sinne. Det påvirker den følelsesmessig og mentale helsen til samfunnet. Ved å stoppe usannheter kan samfunn gjøres mer fleksibel.
- Alle kan stoppe stigma ved å ha faktakunnskap og dele det med de rundt seg.

## Tilleggsinformasjon
- [https://research.bangor.ac.uk/portal/files/19296816/2017_Fake_news.pdf](https://research.bangor.ac.uk/portal/files/19296816/2017_Fake_news.pdf)`,
  },
  activity_handprint_23: {
    title:
      'Jeg viste empati ovenfor personer som er påvirket er pandemien i dag',
    description:
      'Logges hver dag du viste omsorg for noen som er påvirket av COVID-19.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Å være empatisk og altruistisk ovenfor andre (inkludert de syke) skaper en følelse av tilhørighet og reduserer isolasjonsfølelse og fordommer. Det er givende å være snill med de svake, og å minnes hvordan alt i verden henger sammen. Husk, jo mer du gir til andre, jo mer gir du til deg selv!

## Tilleggsinformasjon
- [https://www.verywellmind.com/how-to-practice-empathy-during-the-covid-19-pandemic-4800924](https://www.verywellmind.com/how-to-practice-empathy-during-the-covid-19-pandemic-4800924)
- [https://www.psychologytoday.com/us/blog/social-empathy/201812/five-ways-empathy-is-good-your-health](https://www.psychologytoday.com/us/blog/social-empathy/201812/five-ways-empathy-is-good-your-health)`,
  },
  activity_handprint_24: {
    title:
      'Jeg fortalte en venn eller kollege hvorfor jeg er takkenemlig i dag',
    description:
      'Logges hver dag du tar deg tiden til å takke en kollega eller venn.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Å uttrykke takknemlighet kan ha mange positive effekter, særlig i vanskelige tider.
- Gjennom takknemlighet kan du kjenne deg koblet til noe større enn deg selv, og innse hvor godt du har det. Den psykiske effekten av takknemligheten er blant annet bedre velvære, mer betydningsfulle forhold, økt fysisk og mental helse, optimisme og lykke.

## Tilleggsinformasjon
- [https://positivepsychology.com/gratitude-appreciation/](https://positivepsychology.com/gratitude-appreciation/)
- [https://www.health.harvard.edu/healthbeat/giving-thanks-can-make-you-happier](https://www.health.harvard.edu/healthbeat/giving-thanks-can-make-you-happier)`,
  },
  activity_handprint_25: {
    title: 'Jeg hjalp en nabo i dag',
    description:
      'Logges hver dag du spurte en nabo om du kunne hjelpe de med noe.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Det er viktig å vise medlidenhet overfor andre. Samholdet i nabolaget kan påvirke helsa.

## Tilleggsinformasjon
- [https://academic.oup.com/abm/article-abstract/39/2/170/4566651](https://academic.oup.com/abm/article-abstract/39/2/170/4566651)`,
  },
  activity_handprint_26: {
    title: 'Jeg hilste på en trygg måte i dag',
    description:
      'Logges hver dag du hilste på noen ved å vinke, nikke, eller neie.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- For å hindre spredningen av COVID-19 er det tryggeste å unngå fysisk kontakt når du hilser.
- Luftveisvirus kan spres ved at du håndhilser for å så ta deg i øyene, nesa eller munnen.`,
  },
  activity_handprint_27: {
    title: 'Jeg jobbet for å bli kvitt en uvane i dag',
    description:
      'Logges hver dag du bestemmer deg for å handle for å bli kvitt en uvane.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    health_explanation: `MARKDOWN:
## Fakta
- Bruk denne muligheten til å reflektere over vaner du skulle ønske du kunne droppe! Å slutte med uvaner gir gode vaner som forbedrer fysisk og mental helse.

## Tilleggsinformasjon
- [https://www.lemonade.com/blog/breaking-bad-habits/](https://www.lemonade.com/blog/breaking-bad-habits/)`,
    social_explanation: `MARKDOWN:
## Fakta
- Vi skaper uvaner for å håndtere stress. Prøv å belønne deg selv for å bli kvitt uvanen din.

## Tilleggsinformasjon
- [https://www.researchgate.net/profile/Wander_Jager/publication/251477649_Breaking_'bad_habits'_a_dynamical_perspective_on_habit_formation_and_change/links/0deec53b4f882d03b0000000/Breaking-bad-habits-a-dynamical-perspective-on-habit-formation-and-change.pdf](https://www.researchgate.net/profile/Wander_Jager/publication/251477649_Breaking_'bad_habits'_a_dynamical_perspective_on_habit_formation_and_change/links/0deec53b4f882d03b0000000/Breaking-bad-habits-a-dynamical-perspective-on-habit-formation-and-change.pdf)`,
  },
  activity_handprint_28: {
    title:
      'I had a conversation with another participant about environmental issues.',
    description:
      'Through conversations about the environment, we can help our members embed a decarbonized lifestyle among themselves.',
    points_explanation: `MARKDOWN:
Poengene skal gjenspeile hvor stor påvirkning en aktivitet har på omverdenen.

**5 poeng - individuell påvirkning**<br/>
For eksempel: aktiviteter du kan gjøre på egen hånd uten å måtte kommunisere med eller påvirke andre. 

**10 poeng - sosial påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med noen, inspirere, motivere venner, familie, kollegaer eller en lokal butikk. 

**15 poeng - lokal påvirkning**<br/>
For eksempel: Å gi komplimenter, snakke med, inspirere eller motivere samfunnsorgan som organisasjoner, politikere, kommuner, osv.`,
    handprint_explanation: `MARKDOWN:
## Did you know? 
- What you know about eco-friendly and decarbonised lifestyles may not be known to the other members of the team who are participating in the challenge with you. By sharing that knowledge with other members, you can contribute to the decarbonization of your entire team.`,
  },
};
